import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getSearchProgramTags = (searchText) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_SEARCH_PROGRAM_TAGS(searchText),
    "",
    cancelToken
  );
};

export default getSearchProgramTags;
